import i18next from 'i18next';
import ColumnFilterMultiSelect from '../../components/VehicleTable/components/filters/ColumnFilterMultiSelect';
import { FORMAT_DATE, FORMAT_DATE_TIME } from '../../utils/constants';
import dayjs from 'dayjs';
import filterFn from '../../components/VehicleTable/customFilterFn';

export const columnsData = [
  {
    accessor: 'id',
    id: 'id',
    Header: i18next.t('pud_id'),
    width: 110,
  },
  {
    width: 130,
    accessor: 'licensePlate',
    id: 'licensePlate',
    Header: i18next.t('vehicle_plate'),
  },
  {
    accessor: 'nome_cogome_cliente',
    id: 'nome_cogome_cliente',
    Header: i18next.t('name_and_surname'),
    width: 180,
  },
  {
    accessor: 'status_description',  // (In attesa / Confermata / Annullata)
    id: 'status_description',
    Header: i18next.t('procedure_status'),
    width: 180,
    PrimaryFilter: ColumnFilterMultiSelect,
    filter: filterFn,

  },
  {
    width: 240,
    accessor: 'planExpiration',
    id: 'planExpiration',
    Header: i18next.t('contract_expiration_date'),
    Cell: (data) => {
      const formattedExpirationDate = dayjs(data.row.original.contract_expiration_date).format(FORMAT_DATE)
			return  formattedExpirationDate
		}
  },
  {
    accessor: 'pickup_state', // (Da programmare / Da ritirare / Ritirata)
    id: 'pickup_state',
    Header: i18next.t('pickup_state'),
    width: 190,
  },
  {
    width: 130,
    accessor: 'pickup_date',
    id: 'pickup_date',
    Header: i18next.t('pickup_date'),
    Cell: (data) => {
      const formattedPickupDate = data.row.original.pickup_date ? dayjs(data.row.original.pickup_date).format(FORMAT_DATE_TIME) : ""
			return  formattedPickupDate
		}
  },
  {
    accessor: 'delivery_state', // (Da programmare / Da riconsegnare / Riconsegnata)
    id: 'delivery_state',
    Header: i18next.t('delivery_state'),
    width: 180,
  },
  {
    width: 180,
    accessor: 'delivery_date',
    id: 'delivery_date',
    Header: i18next.t('delivery_date'),
  },
];
